import { FileTextOutlined , DesktopOutlined , BranchesOutlined , CarOutlined , MoneyCollectOutlined , FileOutlined , ApartmentOutlined, CalendarOutlined, ContainerOutlined, DatabaseOutlined, FileSearchOutlined , WechatOutlined, InsertRowBelowOutlined, MessageOutlined, QrcodeOutlined, SettingOutlined, UserOutlined , QuestionCircleOutlined,TeamOutlined, VideoCameraOutlined, RobotOutlined, ShareAltOutlined } from "@ant-design/icons"
import { routes } from "App"
import React from "react"

import addKeyLocalStorage from "helper/localStorage";
import { notification } from "antd";

export const GET_FEATURE_MENU = (translation, setting= {}) => {
  const menu = [
    {
      name: translation("header.accreditation"),
      href: routes.accreditation.path,
      icon: <SettingOutlined />,
      permissionName : routes.accreditation.permissionName,
      routerChildren: [
        routes.listDetailAccreditation.path,
        routes.inspectionProcess.path,
        routes.statisticalAccreditation.path,
        routes.listReportlAccreditation.path,
        routes.accreditationSetting.path,
        "/"
      ],
      keyEnable:ALL_PERMISSION.MANAGE_RECORD.keyEnable,
    },
    {
      name: translation('header.customers'),
      href: routes.listCustomer.path,
      icon: <UserOutlined />,
      permissionName : routes.listCustomer.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_CUSTOMER.keyEnable
    },
    {
      name: translation("listCustomers.message"),
      href: routes.sms.path,
      icon: <MessageOutlined />,
      permissionName : routes.sms.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_SMS.keyEnable
    },
    {
      name: translation('header.schedule'),
      href: routes.customerSchedule.path,
      icon: <CalendarOutlined />,
      permissionName : routes.customerSchedule.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_SCHEDULE.keyEnable
    },
    // {
    //   name: translation('header.receipt'),
    //   href: routes.receipt.path,
    //   icon: <FileTextOutlined />,
    //   permissionName : routes.receipt.permissionName,
    //   routerChildren: [],
    //   keyEnable:ALL_PERMISSION.MANAGE_BILLING.keyEnable
    // },
    {
      name: translation('header.order'),
      href: routes.listOrder.path,
      icon: <FileTextOutlined />,
      permissionName : routes.listOrder.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_ORDER.keyEnable
    },
    {
      name: translation("header.documentary"),
      href: routes.documentary.path,
      icon: <ContainerOutlined />,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_DOCMENTARY.keyEnable
    },
    {
      name: translation('header.device'),
      href: routes.device.path,
      icon: <DesktopOutlined />,
      permissionName : routes.device.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGEMENT_DEVICE.keyEnable
    },
    {
      name: translation('header.management'),
      href: routes.management.path,
      icon: <UserOutlined />,
      permissionName : routes.management.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_APP_USER.keyEnable
    },
    {
      name: translation('header.vehicleRecords'),
      href: routes.vehicleRecords.path,
      icon: <CarOutlined  />,
      permissionName : routes.vehicleRecords.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_VEHICLE_RECORD.keyEnable
    },
    {
      name: translation('header.camera'),
      href: routes.camera.path,
      icon: <VideoCameraOutlined />,
      permissionName : routes.camera.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_CAMERA.keyEnable
    },
    {
      name: translation('header.new'),
      href: routes.news.path,
      icon: <ContainerOutlined />,
      permissionName : routes.news.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_NEWS.keyEnable
    },
    {
      name: translation('header.virtual_assistant_torichat'),
      href: routes.torichat.path,
      icon: <RobotOutlined />,
      permissionName : routes.torichat.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_TORICHAT.keyEnable
    },
    {
      name: translation('header.affiliate_marketing'),
      href: routes.affiliate.path,
      icon: <ShareAltOutlined />,
      permissionName : routes.affiliate.permissionName,
      routerChildren: [],
      keyEnable:ALL_PERMISSION.MANAGE_AFFILIATE.keyEnable
    }
  ]
  menu.forEach(item =>
    warningPermission(item.permissionName)
  );

  // Sử dụng hasPermissionWithSetting để kiểm tra cả quyền và setting
  const filterMenuPermission = menu.filter(item => {
    return hasPermissionWithSetting(item.permissionName, item.keyEnable, setting)
  });

  return filterMenuPermission
}

export const USER_ROLES = {
  ADMIN : 1,
  VEHICLE_INSPECTOR: 2,
  SENIOR_VEHICLE_INSPECTOR: 3,
  PROFESSIONAL_STAFF : 6
} 

export const ROLE_ID_DIRECTOR = 1 // Giám đốc
export const NOT_AUTHENTICATION_PERMISSION = "NOT_AUTHENTICATION_PERMISSION";
export const NOT_ENABLE_KEY = "NOT_ENABLE_KEY";
export const ALL_PERMISSION = {
  MANAGE_RECORD: {
    permission: "MANAGE_RECORD",
    permissionLabel: "Vận hành",
    keyEnable: "enableOperateMenu",
    oldPermission: "MANAGE_RECORD",
    permissionTab: {
      // TAB_OPERATION_CUSTOMERS_TODAY :{
      //   value : "TAB_OPERATION_CUSTOMERS_TODAY",
      //   label : "Khách hàng hôm nay"
      // },
      // TAB_OPERATION_HISTORY :{
      //   value : "TAB_OPERATION_HISTORY",
      //   label : "Lịch sử vận hành"
      // },
      // TAB_OPERATION_PROCESS :{
      //   value : "TAB_OPERATION_PROCESS",
      //   label : "Quy trình vận hành"
      // },
      // TAB_OPERATION_INFORMATION_BOARD :{
      //   value : "TAB_OPERATION_INFORMATION_BOARD",
      //   label : "Bảng thông báo vận hành"
      // },
      // TAB_OPERATION_STATISTICS :{
      //   value : "TAB_OPERATION_STATISTICS",
      //   label : "Thống kê vận hành"
      // },
      // TAB_OPERATION_INSPECTION_REPORT :{
      //   value : "TAB_OPERATION_INSPECTION_REPORT",
      //   label : "Báo cáo kiểm định vận hành"
      // },
      // TAB_OPERATION_SETTINGS :{
      //   value : "TAB_OPERATION_SETTINGS",
      //   label : "Cài đặt vận hành"
      // },
    }
  },
  MANAGE_CUSTOMER: {
  permission: "MANAGE_CUSTOMER",
  permissionLabel: "Khách hàng",
  keyEnable: "enableCustomerMenu",
  oldPermission: "MANAGE_CUSTOMER",
  permissionTab: {
    // TAB_CUSTOMER_LIST: {
    //   value: "TAB_CUSTOMER_LIST",
    //   label: "Danh sách khách hàng"
    // },
    // TAB_CUSTOMER_AUTO_CARE: {
    //   value: "TAB_CUSTOMER_AUTO_CARE",
    //   label: "Tự động CSKH"
    // }
  }
  },
  MANAGE_SMS: {
    permission: "MANAGE_SMS",
    permissionLabel: "Tin nhắn",
    keyEnable: "enableMarketingMessages",
    oldPermission: "MANAGE_SMS",
    permissionTab: {
      // TAB_MESSAGE_LIST: {
      //   value: "TAB_MESSAGE_LIST",
      //   label: "Danh sách tin nhắn"
      // },
      // TAB_MESSAGE_STATISTICS: {
      //   value: "TAB_MESSAGE_STATISTICS",
      //   label: "Thống kê tin nhắn"
      // }
    }
  },
  MANAGE_SCHEDULE: {
    permission: "MANAGE_SCHEDULE",
    permissionLabel: "Lịch hẹn",
    keyEnable: "enableScheduleMenu",
    oldPermission: "MANAGE_SCHEDULE",
    permissionTab: {
      // TAB_SCHEDULE_LIST: {
      //   value: "TAB_SCHEDULE_LIST",
      //   label: "Danh sách lịch hẹn"
      // },
      ADD_SCHEDULE: {
        value: "ADD_SCHEDULE",
        label: "Đặt lịch hẹn"
      },
      // TAB_SCHEDULE_DAY_OFF: {
      //   value: "TAB_SCHEDULE_DAY_OFF",
      //   label: "Lịch nghỉ của trạm",
      //   isAdmin: true
      // },
      // TAB_SCHEDULE_SETUP: {
      //   value: "TAB_SCHEDULE_SETUP",
      //   label: "Thiết lập lịch hẹn",
      //   isAdmin: true
      // },
      // TAB_SCHEDULE_LOOKUP: {
      //   value: "TAB_SCHEDULE_LOOKUP",
      //   label: "Tra cứu lịch hẹn"
      // }
    }
  },
  MANAGE_BILLING: {
    permission: "MANAGE_BILLING",
    permissionLabel: "Hóa đơn",
    keyEnable: "enableInvoiceMenu",
    oldPermission: "MANAGE_BILLING",
    permissionTab: {
      // TAB_MESSAGE_LIST: {
      //   value: "TAB_INVOICE_LIST",
      //   label: "Danh sách hóa đơn"
      // }
    }
  },
  MANAGE_DOCMENTARY: {
    permission: "MANAGE_DOCMENTARY",
    permissionLabel: "Tài liệu",
    keyEnable: "enableDocumentMenu",
    oldPermission: "MANAGE_DOCMENTARY",
    permissionTab: {
      // TAB_DOCUMENT_DISPATCH: {
      //   value: "TAB_DOCUMENT_DISPATCH",
      //   label: "Danh sách công văn"
      // },
      MANAGE_FILE: {
        value: "MANAGE_FILE",
        label: "Danh sách hồ sơ"
      }
    }
  },
  MANAGEMENT_DEVICE: {
    permission: "MANAGEMENT_DEVICE",
    permissionLabel: "Thiết bị",
    keyEnable: "enableDeviceMenu",
    oldPermission: NOT_AUTHENTICATION_PERMISSION,
    permissionTab: {
      // TAB_DEVICE_LIST: {
      //   value: "TAB_DEVICE_LIST",
      //   label: "Danh sách thiết bị"
      // }
    }
  },
  MANAGE_APP_USER: {
    permission: "MANAGE_APP_USER",
    permissionLabel: "Nhân sự",
    keyEnable: "enableManagerMenu",
    oldPermission: "MANAGE_APP_USER",
    permissionTab: {
      // TAB_HUMAN_RESOURCES_MANAGEMENT: {
      //   value: "TAB_HUMAN_RESOURCES_MANAGEMENT",
      //   label: "Quản lý nhân sự"
      // },
      // TAB_HUMAN_RESOURCES_ASSIGNMENT: {
      //   value: "TAB_HUMAN_RESOURCES_ASSIGNMENT",
      //   label: "Phân công nhân sự"
      // },
      //   TAB_HUMAN_RESOURCES_PERMISSION: {
      //   value: "TAB_HUMAN_RESOURCES_PERMISSION",
      //   label: "Phân quyền nhân sự"
      // },
      // TAB_HUMAN_RESOURCES_HISTORY: {
      //   value: "TAB_HUMAN_RESOURCES_HISTORY",
      //   label: "Lịch sử phân công"
      // }
    }
  },
  MANAGE_VEHICLE_RECORD : {
    permission: "MANAGE_VEHICLE_RECORD",
    permissionLabel: "Hồ sơ phương tiện",
    keyEnable: "enableVehicleRegistrationMenu",
    oldPermission: "MANAGE_VEHICLE_RECORD",
    permissionTab: {
      // TAB_VEHICLE_RECORD_LIST: {
      //   value: "TAB_VEHICLE_RECORD_LIST",
      //   label: "Danh sách hồ sơ phương tiện"
      // },
      // TAB_VEHICLE_RECORD_LOOKUP: {
      //   value: "TAB_VEHICLE_RECORD_LOOKUP",
      //   label: "Phân công nhân sự"
      // }
    }
  },
  MANAGE_CAMERA : {
    permission: "MANAGE_CAMERA",
    permissionLabel: "Camera",
    keyEnable: "enableCameraMenu",
    oldPermission: "MANAGE_CAMERA",
    permissionTab: {
      // TAB_CAMERA_LIST: {
      //   value: "TAB_CAMERA_LIST",
      //   label: "Danh sách camera"
      // }
    }
  },
  MANAGE_NEWS : {
    permission: "MANAGE_NEWS",
    permissionLabel: "Tin tức",
    keyEnable: "enableNewsMenu",
    oldPermission: "MANAGE_NEWS",
    permissionTab: {}
  },
  MANAGE_PHONEBOOK : {
    permission: "MANAGE_PHONEBOOK",
    permissionLabel: "Danh bạ",
    keyEnable: "enableContactMenu",
    oldPermission: "MANAGE_PHONEBOOK",
    permissionTab: {}
  },
  MANAGE_SETTINGS : {
    permission: "MANAGE_SETTINGS",
    permissionLabel: "Cài đặt",
    keyEnable: "enableSettingstMenu",
    oldPermission: "MANAGE_SETTINGS",
    permissionTab: {
      // TAB_SETTINGS_GENERAL_INFORMATION: {
      //   value: "TAB_SETTINGS_GENERAL_INFORMATION",
      //   label: "Cài đặt thông tin chung"
      // },
      // TAB_SETTINGS_SERVICE: {
      //   value: "TAB_SETTINGS_SERVICE",
      //   label: "Cài đặt dịch vụ"
      // },
      // TAB_SETTINGS_EXPANSION: {
      //   value: "TAB_SETTINGS_EXPANSION",
      //   label: "Cài đặt mở rộng"
      // },
      // TAB_SETTINGS_EXPANSION: {
      //   value: "TAB_SETTINGS_MINIAPP",
      //   label: "Cài đặt miniApp"
      // },
      //   TAB_SETTINGS_CONNECTION: {
      //   value: "TAB_SETTINGS_CONNECTION",
      //   label: "Cài đặt kết nối"
      // },
      // TAB_SETTINGS_PAYMENT_METHOD: {
      //   value: "TAB_SETTINGS_PAYMENT_METHOD",
      //   label: "Cài đặt phương thức thanh toán"
      // }
    }
  },
  MANAGE_CHAT : {
    permission: "MANAGE_CHAT",
    permissionLabel: "Chat",
    keyEnable: "enableChatMenu",
    oldPermission: "MANAGE_CHAT",
    permissionTab: {}
  },
  MANAGE_GUIDE : {
    permission: "MANAGE_GUIDE",
    permissionLabel: "Hướng dẫn",
    keyEnable: undefined,
    oldPermission: "MANAGE_GUIDE",
    permissionTab: {}
  },
  MANAGE_ORDER : {
    permission: "MANAGE_ORDER",
    permissionLabel: "Đơn hàng",
    keyEnable: "enableOrderMenu",
    oldPermission: "MANAGE_ORDER",
    permissionTab: {}
  },
  MANAGE_TORICHAT : {
    permission: "MANAGE_TORICHAT",
    permissionLabel: "Trợ lý ảo TORICHAT",
    keyEnable: "enableToriChatMenu",
    oldPermission: "MANAGE_TORICHAT",
    permissionTab: {}
  },
  MANAGE_AFFILIATE : {
    permission: "MANAGE_AFFILIATE",
    permissionLabel: "Tiếp thị liên kết",
    keyEnable: "enableAffiliateMenu",
    oldPermission: "MANAGE_AFFILIATE",
    permissionTab: {
      MANAGE_LIST_ORDER: {
        value: "MANAGE_LIST_ORDER",
        label: "Danh sách đơn hàng tiếp thị liên kết"
      },
      MANAGE_SUMMARY: {
        value: "MANAGE_SUMMARY",
        label: "Danh sách tổng kết tiếp thị liên kết"
      }
    }
  },
}

export const getAllPermissionFormatString = () => {
  return Object.values(ALL_PERMISSION)
    .flatMap(({ permission, permissionTab }) => [
      permission,
      ...Object.values(permissionTab || {}).map(({ value }) => value)
    ])
    .join(',');
}
export const getAllPermissionFormatArray = () => {
  return Object.values(ALL_PERMISSION).flatMap(group => {
    const groupPermission = group.permission && group.permissionLabel
      ? [{ value: group.permission, label: group.permissionLabel }]
      : []

    const tabPermissions = group.permissionTab
      ? Object.values(group.permissionTab).map(tab => ({
          value: tab.value,
          label: tab.label,
        }))
      : []

    return [...groupPermission, ...tabPermissions]
  })
}

export const getPermissionsForUser = ()=>{
  const data = JSON.parse(window.localStorage.getItem(addKeyLocalStorage('data')))
  let permission = ''
  if (data?.permissions) {
    permission = data?.permissions
    if (data?.appUserRoleId === ROLE_ID_DIRECTOR) {
      permission = getAllPermissionFormatString()
    }
  }
  return permission
}

export const hasPermission = (permissionToCheck) => {
  if (!permissionToCheck || (Array.isArray(permissionToCheck) && permissionToCheck.length === 0)) {
    // Không truyền gì hoặc mảng rỗng
    return true
  }

  const userPermissions = getPermissionsForUser().split(',').map(p => p.trim())

  if (Array.isArray(permissionToCheck)) {
    return permissionToCheck.some(p => userPermissions.includes(p))
  }

  return userPermissions.includes(permissionToCheck)
}

/**
 * Kiểm tra quyền kết hợp với setting enableMenu
 * @param {string|array} permission - Quyền cần kiểm tra
 * @param {string} keyEnable - Key trong setting (vd: enableOrderMenu)
 * @param {object} setting - Object setting từ redux
 * @returns {boolean} - true nếu có quyền VÀ feature được enable trong setting
 */
export const hasPermissionWithSetting = (permission, keyEnable, setting = {}) => {
  // Kiểm tra quyền trước
  if (!hasPermission(permission)) {
    return false
  }

  // Nếu không có keyEnable hoặc là NOT_ENABLE_KEY thì không cần kiểm tra setting
  if (!keyEnable || keyEnable === NOT_ENABLE_KEY) {
    return true
  }

  // A feature is available only when the station explicitly enables it.
  return setting?.[keyEnable] === 1
}

export const warningPermission = (permissionToCheck) => {
  const userPermissions = getAllPermissionFormatString().split(',').map(p => p.trim())

  let isError = false

  if (!permissionToCheck || (Array.isArray(permissionToCheck) && permissionToCheck.length === 0)) {
    // Không truyền gì hoặc mảng rỗng
    return
  } else if (Array.isArray(permissionToCheck)) {
    if (!permissionToCheck.some(p => userPermissions.includes(p))) {
       isError = true
    }
  } else{
    if (!userPermissions.includes(permissionToCheck)) {
      isError = true
    }
  }
  
  return isError && notification["error"]({
      message: "",
      description: `⚠️ Quyền "${permissionToCheck}" không nằm trong ALL_PERMISSION ở constants/permission.js`,
    });
}

